import {React, classNames, StyledProps, useCallback, utils, observable, observer, action, useAsObservableSource, useLocalStore} from '@api'
import {autorun, reaction} from 'mobx'
import {useEffect, useLayoutEffect, useState} from 'react'
import { Collapse, ListItem, ListItemText } from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import {_} from '../../3rd-party'
import * as css from './CollapsibleStateful.css'

interface MyProps extends StyledProps {
  title?: string | React.ReactNode,
  open?: boolean,
  onToggleOpen?: (open: boolean) => void
  defaultOpen?: boolean
  hideExpandCollapseButton?: boolean

  /**
   * Super slow vs just doing some CSS
   */
  useMaterialCollapse?: boolean
}

// @(withStyles as any)(styles)
// export class CollapsibleStateful extends React.Component<MyProps> {
//   static defaultProps = {
//     title: ''
//   }
//   const [open, setOpen] = useState(true)

//   render() {
//     const {handleClick, classes, title, open, className, children} = this.props
//     return (<div className={classNames(css.root, classes?.root, className)} data-open={open}>
//         <ListItem className={classes?.list} disableGutters onClick={handleClick}>
//           <ListItemText primaryTypographyProps={{classes: {subheading: classes?.primary}}} primary={title}/>
//           {open ? <ExpandLess classes={{root: classes?.icon}}/> : <ExpandMore classes={{root: classes?.icon}}/>}
//         </ListItem>
//         <Collapse in={open} unmountOnExit classes={{wrapperInner: classes?.wrapperInner, container: classes?.container}} >
//           {children}
//         </Collapse>
//       </div>
//     )
//   }
// }

class CollapsibleStatefulStore {
  constructor(public props: MyProps) {
    this.open = this.everOpen = props.open === true || props.defaultOpen
  }

  registerEffects = () => {
    // console.log(`mount`)
    const _toDispose = [
      reaction(() => this.open === true, () => this.everOpen = true),
      autorun(() => {
        if (_.isBoolean(this.props.open)) {
          this.open = this.props.open === true
        }
      })
    ]

    return () => {
      _toDispose.forEach(d => d())
      // console.log(`unmount`)
    }
  }

  @observable open : boolean = false

  @observable everOpen = false

  @action onToggleOpen = () => {
    this.open = !this.open
    if (this.props.onToggleOpen) {
      this.props.onToggleOpen(this.open)
    }
  }

  @action onDoubleClick = e => {
    this.onToggleOpen()
    utils.eatMouseEvent(e)
  }
}
export const CollapsibleStateful : React.FC<Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> & MyProps> = observer(function CollapsibleStateful({classes, hideExpandCollapseButton, useMaterialCollapse, title, className, children, ...props}) {
  const obsProps = useAsObservableSource(({..._.pick(props, ['open', 'defaultOpen', 'onToggleOpen'])})),
    {onToggleOpen, open, everOpen, onDoubleClick, registerEffects} = useLocalStore(() => new CollapsibleStatefulStore(obsProps))

  useLayoutEffect(() => registerEffects(), [])

  return (<div className={classNames(css.root, classes?.root, className)}
               data-open={open}
               {..._.omit(props, ['onToggleOpen', 'defaultOpen'])}
               data-type='CollapsibleStateful'>
        <ListItem className={classNames(css.list, classes?.list)} disableGutters data-type='Header' onDoubleClick={onDoubleClick}>
          <ListItemText primaryTypographyProps={{classes: {subtitle1: classNames(css.primary, classes?.primary)}}} primary={title} data-type='Title'/>
          {!hideExpandCollapseButton && <ExpandLess onClick={onToggleOpen} classes={{root: classNames(css.icon, css.expandCollapseIcon, classes?.icon)}}/>}
        </ListItem>
    {useMaterialCollapse ? <Collapse in={open}
                  unmountOnExit={true}
                  mountOnEnter={true}
                  classes={{wrapperInner: classNames(css.wrapperInner, classes?.wrapperInner)}}
                  data-type='CollapseContainer' >
          {children}
        </Collapse>
     : <div className={classNames(css.wrapperInner, css.hideWhenClosed)}>
       {everOpen ? children : null}
     </div>}
    </div>
    )
})

CollapsibleStateful.defaultProps = {useMaterialCollapse: true}


// WEBPACK FOOTER //
// ./src/shared/components/ui/components/CollapsibleStateful.tsx